import { sendToApi } from 'api/client'
import { CrossPostAccount } from 'components/Wizards/Wizard/Form/CrossPostAccountsInput/CrossPostAccountsInput'
import { rootStore } from 'stores/RootStore'
import { AlmanacFile, GeneratePrompt } from 'types'

export enum GenerationType {
  Article = 'article',
  Outline = 'outline',
  Brainstorm = 'brainstorm',
  ContentBrief = 'content_brief',
  Generic = 'generic',
  InlineGeneric = 'inline_generic',
  Campaign = 'campaign',
  SEOPlanning = 'seo_planning',
  InstagramPlanning = 'instagram_planning',
  TwitterPlanning = 'twitter_planning',
  FacebookPlanning = 'facebook_planning',
  LinkedInPlanning = 'linkedin_planning',
  Image = 'image',
  ContentPlan = 'content_plan',
}

export interface GenerationRequestProps {
  workspaceId: number
  prompt: GeneratePrompt
  isTurnInto?: boolean
  projectId?: number | string
  // TODOL: Fork this type into something like: GenerateNew or ModifyExisting
  articleId?: string | null
  mode?: string
  title?: string
  selection?: { [key: string]: any }
  promptLibrary?: string
  crossPostAccounts?: CrossPostAccount[]
}

export const createDocGenerationRequest = ({
  workspaceId,
  prompt,
  projectId,
  articleId,
  title,
  mode,
  isTurnInto,
  selection,
  promptLibrary,
  crossPostAccounts,
}: GenerationRequestProps) => {
  const startedAt = rootStore.timerStore.fetchAndResetTimer()

  return sendToApi<{
    almanac_file: AlmanacFile
  }>(`/w/${workspaceId}/generate_doc`, {
    method: 'POST',
    body: {
      prompt,
      project_id: projectId,
      article_id: articleId,
      mode: articleId ? mode ?? 'append' : undefined,
      selection,
      title,
      is_turn_into: !!isTurnInto,
      started_at: startedAt,
      prompt_library: promptLibrary,
      cross_post_accounts: crossPostAccounts,
    },
  })
}
